export default "__VITE_ASSET__5b3debb5__"